import React from 'react';
import PropTypes from 'prop-types';

import { Container, WarningIcon, ErrorIcon, Content } from './Callout.styled';

export const CalloutTypes = {
  WARN: 'warn',
  ERROR: 'error',
};

const Callout = ({ children, type }) => (
  <Container type={type} role="alert">
    {type === CalloutTypes.ERROR ? (
      <ErrorIcon fontSize="small" />
    ) : (
      <WarningIcon fontSize="small" />
    )}
    <Content>{children}</Content>
  </Container>
);

Callout.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(Object.values(CalloutTypes)),
};

Callout.defaultProps = {
  type: CalloutTypes.WARN,
};

export default Callout;
